import { LoginForm } from "@/features/auth/login/LoginForm/LoginForm";
import { useLogin } from "@/shared/hooks/useAuth";
import { type LoginFormData } from "@/shared/lib/validation";

import { AxiosError } from "axios";
import { observer } from "mobx-react-lite";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import AuthVk from "@/features/auth/VkAuth/vkAuth";
import styles from "./LoginPage.module.css";

export const LoginPage: React.FC = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const loginMutation = useLogin();

  const handleLogin = async (data: LoginFormData) => {
    try {
      await loginMutation.mutateAsync(data);

      const from =
        (location.state as { from?: { pathname: string } })?.from?.pathname ||
        "/";

      navigate(from, { replace: true });
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  const getErrorMessage = (): string => {
    if (!loginMutation.error) return "";

    const error = loginMutation.error as AxiosError;
    if (error?.response?.status === 401 || error?.response?.status === 400) {
      return "Неверные учетные данные";
    }
    return `Ошибка при входе в систему: ${error?.response?.status || "неизвестная ошибка"}`;
  };

  return (
    <div className={styles.container}>
      <div className={styles.background}>
        <div className={styles.backgroundBlur1}></div>
        <div className={styles.backgroundBlur2}></div>
        <div className={styles.backgroundBlur3}></div>
      </div>

      <div className={styles.content}>
        <LoginForm
          onSubmit={handleLogin}
          isLoading={loginMutation.isPending}
          error={getErrorMessage()}
        />
        <AuthVk />
      </div>
    </div>
  );
});
